var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventdetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 35.4167H15.8751L16.9167 43.75H33.1042L34.1459 35.4167H45.8334V6.25H4.16675V35.4167ZM19.0209 27.0833H22.9167V31.25H19.5417L19.0209 27.0833ZM30.4376 31.25H27.0834V27.0833H30.9792L30.4376 31.25ZM20.0209 35.4167H22.9167V39.5833H20.5834L20.0209 35.4167ZM27.0834 39.5833V35.4167H29.9376L29.4167 39.5833H27.0834ZM8.33341 10.4167H41.6667V31.25H34.6459L35.6876 22.9167H14.3126L15.3542 31.25H8.33341V10.4167Z",
    fill: "#394150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventdetails);
export default __webpack_public_path__ + "static/media/eventdetails.ee278d43dfa6f364b11c84fa08a818ee.svg";
export { ForwardRef as ReactComponent };